import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Leser innstillingen 'picking.largeText' (TW 36393697, Haucon nettbrett).
 *
 * På: større skrift og trykkmål i plukkbildet — aktiv linje, linjelista og toppikonene.
 * Av (default): uendret visning. Oppløsning Profil → System → Default via getEffectiveSetting,
 * så håndterminaler er urørt så lenge innstillingen er av på deres profil.
 */
export function usePickingLargeText(): boolean {
  const [enabled, setEnabled] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    settingsService.getEffectiveSetting('picking.largeText')
      .then(setting => {
        if (cancelled) return;
        if (setting && setting.currentValue !== null && setting.currentValue !== undefined) {
          const val = setting.currentValue.toString().toLowerCase();
          setEnabled(val === 'true' || val === '1' || val === 'ja');
        } else {
          setEnabled(false);
        }
      })
      .catch(err => {
        console.warn('Could not load picking.largeText setting, defaulting to false:', err);
        if (!cancelled) setEnabled(false);
      });

    return () => { cancelled = true; };
  }, []);

  return enabled;
}
